// brazilV2Language.ts
// ─── Astria Brazil v2 — EN/PT language ──────────────────────────────────
// Follows the user's preferred language (utils/appLanguage.ts): PT when
// that is the preference, English otherwise. No per-screen toggle.
import { getAppLanguage, pickLanguage, useAppLanguage } from "../../../utils/appLanguage";

export type BrazilV2Lang = "en" | "pt";

const SUPPORTED: readonly BrazilV2Lang[] = ["en", "pt"];
const ALIASES: Partial<Record<string, BrazilV2Lang>> = {};

const resolve = (appLanguage: string): BrazilV2Lang =>
  pickLanguage(appLanguage, SUPPORTED, ALIASES);

export const getBrazilV2Lang = (): BrazilV2Lang => resolve(getAppLanguage());

export function useBrazilV2Language(): BrazilV2Lang {
  return resolve(useAppLanguage());
}
